export default {
  appLoading: false,
  token: JSON.parse(localStorage.getItem('token')) || null,
  barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
  barImage: null,
  drawer: null,
}
